import PropTypes from 'prop-types'
import { useEffect, useCallback, useState } from 'react'
//
import { useRouter } from 'src/routes/hooks'
import { paths } from 'src/routes/paths'
import { useLocation } from 'react-router'
import keycloak from 'src/utils/keycloak'
import { useAuthContext } from '../hooks'

// ----------------------------------------------------------------------

export default function AuthGuard({ children }) {
  const { setRedirect } = useAuthContext()

  const [checked, setChecked] = useState(false)

  const { isLoggedIn } = keycloak

  const router = useRouter()

  const location = useLocation()

  const check = useCallback(() => {
    if (isLoggedIn()) {
      setChecked(true)
    }
  }, [isLoggedIn])

  useEffect(() => {
    check()
  }, [check])

  useEffect(() => {
    setRedirect(location.pathname)
  }, [location, setRedirect])

  useEffect(() => {
    if (!isLoggedIn()) {
      router.replace(paths.login)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router])

  if (!checked) {
    return null
  }

  return <>{children}</>
}

AuthGuard.propTypes = {
  children: PropTypes.node,
}
